import { setProgress } from 'handlers/settingsSlice';
import { useAppDispatch } from 'hooks/reduxHooks';

export enum AppProcessSteps {
  ApplyProcessStep = 'ApplyProcessStep',
  VerificationStep = 'VerificationStep',
  IncomeInformationStep = 'IncomeInformationStep',
  AcceptLegalDocumentsStep = 'AcceptLegalDocumentsStep',
}

export const useAppProgressBar = () => {
  const dispatch = useAppDispatch();

  const resetProgress = () => {
    dispatch(setProgress(null));
  };

  const setProgressStep = (step?: AppProcessSteps | null) => {
    switch (step) {
      case AppProcessSteps.ApplyProcessStep:
        dispatch(setProgress(1));
        break;
      case AppProcessSteps.VerificationStep:
        dispatch(setProgress(2));
        break;
      case AppProcessSteps.IncomeInformationStep:
        dispatch(setProgress(3));
        break;
      case AppProcessSteps.AcceptLegalDocumentsStep:
        dispatch(setProgress(4));
        break;
      case null:
        resetProgress();
        break;
      default:
    };
  };

  return {
    resetProgress,
    setProgressStep,
  };
};
